import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { ReactSVG } from 'react-svg';
import { AuthorizedRoutePaths, settingsRedirectionMap } from 'Interfaces/RoutePaths';

import LockIcon from 'Assets/images/icons/lock.svg';

interface BilletProps {
  title: string;
}

const Billet = ({ title }: BilletProps) => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate(settingsRedirectionMap[AuthorizedRoutePaths.SETTINGS_BILLING_PLAN]);
  }, [navigate]);

  return (
    <div className="company__billet" onClick={handleClick}>
      <ReactSVG src={LockIcon} className="company__billet-icon" />
      <div className="company__billet-text">{title}</div>
    </div>
  );
};

export default Billet;
